/* ZTX-039 — Makale sayfası betiği (harici kütüphane yok, defer).
 * 1) İçindekiler: kutular sunucuda gelir; JS gövdedeki doğrudan h2'lerden bağlantıları doldurur (en az 2 h2), başlıklara Türkçe karakterden arındırılmış id verir.
 *    Masaüstünde yapışkan yan sütun, mobilde gövde başında açılır-kapanır "Bu yazıda".
 * 2) Scroll-spy: okunan bölümün bağlantısı aria-current="location" alır.
 * 3) Okuma ilerleme çubuğu: gövde içindeki konuma göre scaleX (geçiş animasyonu yok; reduced-motion'da da yalnız konum).
 * 4) Bağlantıyı kopyala: Clipboard API; başarısızsa kullanıcıya adres çubuğunu önerir. Kör tekrar yok.
 * JS çalışmazsa: içindekiler ve kopyala düğmesi gizli kalır; makale, WhatsApp bağlantısı ve tüm içerik çalışır.
 */
(function () {
  'use strict';
  var kok = document.querySelector('[data-zt-makale]');
  if (!kok) return;
  var govde = kok.querySelector('[data-zt-govde]');
  var azHareket = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function kimlikYap(metin, kullanilan) {
    var harita = { 'ç': 'c', 'ğ': 'g', 'ı': 'i', 'i̇': 'i', 'ö': 'o', 'ş': 's', 'ü': 'u', 'â': 'a', 'î': 'i', 'û': 'u' };
    var s = metin.toLocaleLowerCase('tr-TR').replace(/[çğıöşüâîû]|i̇/g, function (h) { return harita[h] || h; })
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'bolum';
    var aday = s, n = 2;
    while (kullanilan[aday] || document.getElementById(aday)) { aday = s + '-' + n++; }
    kullanilan[aday] = true;
    return aday;
  }

  /* ---- 1) İçindekiler ---- */
  var basliklar = govde ? Array.prototype.slice.call(govde.querySelectorAll(':scope > h2')) : [];
  var baglantilar = [];
  /* Kutular sunucuda (Liquid, h2 >= 2) gösterilir; JS yalnız bağlantıları doldurur (CLS yok). Doğrudan h2 sayısı yetmezse gizlenir. */
  if (basliklar.length < 2) {
    kok.querySelectorAll('[data-zt-ic-mobil], [data-zt-ic-masa]').forEach(function (e) { e.hidden = true; });
  }
  if (basliklar.length >= 2) {
    var kullanilan = {};
    basliklar.forEach(function (h) { if (!h.id) h.id = kimlikYap(h.textContent.trim(), kullanilan); });
    kok.querySelectorAll('[data-zt-ic-liste]').forEach(function (ol) {
      basliklar.forEach(function (h) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        ol.appendChild(li);
        baglantilar.push(a);
      });
    });
    var mobil = kok.querySelector('[data-zt-ic-mobil]');
    kok.addEventListener('click', function (e) {
      var a = e.target.closest('[data-zt-ic-liste] a');
      if (!a) return;
      var hedef = document.getElementById(a.getAttribute('href').slice(1));
      if (!hedef) return;
      e.preventDefault();
      hedef.scrollIntoView({ behavior: azHareket ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + hedef.id);
      /* Odak başlığa taşınır (klavye/ekran okuyucu kullanıcısı okumaya oradan devam eder) */
      hedef.setAttribute('tabindex', '-1');
      hedef.focus({ preventScroll: true });
      if (mobil && mobil.contains(a)) mobil.open = false;
    });
  }

  /* ---- 2) Scroll-spy + 3) Okuma çubuğu (tek rAF) ---- */
  var cubuk = kok.querySelector('[data-zt-okuma-cubuk]');
  var ustBolum = (document.querySelector('.zt-ust') || {}).closest ? document.querySelector('.zt-ust').closest('.shopify-section') : null;
  var bekliyor = false, aktif = -1, ustH = -1;
  function guncelle() {
    bekliyor = false;
    if (!govde) return;
    /* Yapışkan üst bar yüksekliği (masaüstünde ~171 px, telefonda ~57 px görünür): yan sütun ve başlık kaydırma payı buna göre */
    var yeniH = ustBolum ? Math.max(0, Math.round(ustBolum.getBoundingClientRect().bottom)) : 0;
    if (yeniH !== ustH) { ustH = yeniH; kok.style.setProperty('--zt-ust-h', ustH + 'px'); }
    var r = govde.getBoundingClientRect();
    var gh = window.innerHeight;
    if (cubuk) {
      var toplam = r.height - gh * 0.6;
      var oran = toplam > 0 ? Math.min(1, Math.max(0, -r.top / toplam)) : (r.top < 0 ? 1 : 0);
      cubuk.style.transform = 'scaleX(' + oran.toFixed(4) + ')';
    }
    if (basliklar.length >= 2) {
      var esik = ustH + 40, yeni = -1;
      for (var i = 0; i < basliklar.length; i++) {
        if (basliklar[i].getBoundingClientRect().top - esik <= 0) yeni = i; else break;
      }
      if (yeni !== aktif) {
        aktif = yeni;
        baglantilar.forEach(function (a) {
          var esles = aktif >= 0 && a.getAttribute('href') === '#' + basliklar[aktif].id;
          if (esles) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
        });
      }
    }
  }
  function iste() { if (!bekliyor) { bekliyor = true; requestAnimationFrame(guncelle); } }
  window.addEventListener('scroll', iste, { passive: true });
  window.addEventListener('resize', iste, { passive: true });
  guncelle();

  /* ---- 4) Bağlantıyı kopyala ---- */
  kok.querySelectorAll('[data-zt-kopyala]').forEach(function (b) {
    if (!(navigator.clipboard && window.isSecureContext)) return; /* destek yoksa düğme gizli kalır */
    b.hidden = false;
    var etiket = b.querySelector('[data-zt-kopyala-metin]');
    var ilk = etiket ? etiket.textContent : '';
    b.addEventListener('click', function () {
      var durum = b.closest('.zt-paylas').querySelector('[data-zt-kopyala-durum]');
      navigator.clipboard.writeText(b.getAttribute('data-zt-kopyala')).then(function () {
        if (etiket) etiket.textContent = 'Kopyalandı';
        if (durum) durum.textContent = 'Bağlantı panoya kopyalandı.';
        clearTimeout(b._t);
        b._t = setTimeout(function () { if (etiket) etiket.textContent = ilk; if (durum) durum.textContent = ''; }, 2500);
      }, function () {
        if (durum) durum.textContent = 'Bağlantı kopyalanamadı. Adres çubuğundaki bağlantıyı kopyalayabilirsiniz.';
        if (etiket) etiket.textContent = 'Kopyalanamadı';
      });
    });
  });
})();
